<template>
  <div
    class="tenant-navigation-shell"
    v-show="themeReady"
    :style="themeStyle"
  >
    <div class="tenant-top-nav">
      <div class="tenant-top-nav-main">
        <div
          class="tenant-top-nav-brand"
          :class="{ 'tenant-top-nav-brand--mobile': mobile }"
        >
          <img
            v-if="logoUrl"
            class="tenant-top-nav-logo"
            :src="logoUrl"
            alt=""
          />
          <span v-if="!mobile" class="tenant-top-nav-title">
            {{ tenantName }}
          </span>
        </div>
        <el-menu
          class="tenant-top-nav-menu"
          :default-active="activeAppCode"
          mode="horizontal"
          :background-color="themeColor"
          text-color="#fff"
          active-text-color="#fff"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="item in normalizedApps"
            :key="item.code"
            :index="item.code"
            @click="navigate(item)"
          >
            <svg-icon
              class="tenant-top-nav-item-icon"
              :iconName="resolveAppIcon(item.code)"
            />
            <span v-if="!mobile" class="tenant-top-nav-item-label">
              {{ item.name }}
            </span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="tenant-top-nav-actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="tenant-navigation-content">
      <slot />
    </div>
  </div>
</template>

<script>
import { resolveAppIcon } from '@/utils/app-navigation'
import {
  DEFAULT_THEME_COLOR,
  applyTenantFavicon,
  applyTenantThemeToDocument,
  createThemeStyle,
  getTenantThemeRequestKey,
  loadTenantThemeColor,
  parseTenantThemeRequestKey
} from '@/utils/tenant-theme'

export default {
  name: 'TenantNavigationShell',
  props: {
    activeAppCode: {
      type: String,
      required: true
    },
    apps: {
      type: Array,
      default: () => []
    },
    authInfo: {
      type: Object,
      default: null
    },
    logoUrl: {
      type: String,
      default: ''
    },
    tenantName: {
      type: String,
      default: ''
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      themeColor: DEFAULT_THEME_COLOR,
      themeReady: false
    }
  },
  computed: {
    normalizedApps() {
      return Array.isArray(this.apps) ? this.apps.filter(Boolean) : []
    },
    themeRequestKey() {
      return getTenantThemeRequestKey(this.authInfo, this.logoUrl)
    },
    themeStyle() {
      return createThemeStyle(this.themeColor)
    }
  },
  watch: {
    themeRequestKey: {
      immediate: true,
      handler(requestKey) {
        this.refreshTenantTheme(requestKey)
        this.refreshTenantFavicon(requestKey)
      }
    }
  },
  methods: {
    resolveAppIcon,
    refreshTenantFavicon(requestKey) {
      const request = parseTenantThemeRequestKey(requestKey)
      if (!request) return
      applyTenantFavicon(
        request.logoUrl,
        undefined,
        request.tenantCode
      )
    },
    async refreshTenantTheme(requestKey) {
      this.themeReady = false
      if (!requestKey) return
      const request = parseTenantThemeRequestKey(requestKey)
      if (!request) return
      const color = await loadTenantThemeColor(
        request.logoUrl,
        undefined,
        request.tenantCode
      )
      if (this.themeRequestKey !== requestKey) return
      this.themeColor = color
      applyTenantThemeToDocument(color)
      this.themeReady = true
    },
    navigate(item) {
      if (!item || !item.code || item.code === this.activeAppCode) return
      this.$emit('navigate', item)
    },
    handleSelect(key, keyPath) {
      this.$emit('select', key, keyPath)
    }
  }
}
</script>
